import mitt, { type Emitter } from "mitt";
import type { ToastMessageOptions } from "primevue/toast";
import type { DataTableFilterMeta } from "primevue/datatable";

type ApplicationEvents = {
  "toast": ToastMessageOptions;
  "filters:update": DataTableFilterMeta;
  "email-deliver-status": undefined;
  "notifications:refresh": undefined;
  "editObject": number;
  "showObject": number;
};

declare module "#app" {
  interface NuxtApp {
    $eventBus: Emitter<ApplicationEvents>;
  }
}

declare module "vue" {
  interface ComponentCustomProperties {
    $eventBus: Emitter<ApplicationEvents>;
  }
}

export default defineNuxtPlugin(() => {
  const emitter = mitt<ApplicationEvents>();

  return {
    provide: {
      eventBus: emitter,
    },
  };
});
